import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatInput } from '@angular/material/input'
import { MatTooltip } from '@angular/material/tooltip'
import { MatSelectModule } from '@angular/material/select'
import { MatOption } from '@angular/material/core'
import { MatDialog } from '@angular/material/dialog'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import moment from 'moment'
import { SearchReservationTgModel } from '../../../core/models/purchase-reservation.model'
import { PurchaseServiceOrderService } from '../../../core/services/purchase-reservation/purchase-service-order/purchase-service-order.service'
import { ModalEmployeeConsultantOperationalComponent } from '../../../features/employee/modal-employee-consultant-operational/modal-employee-consultant-operational.component'
import { ModalLegalEntityClientComponent } from '../../../features/customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'

@Component({
  selector: 'form-search-purchase-reservation-tg',
  imports: [
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatSelectModule,
    MatOption,
  ],
  templateUrl: './form-search-purchase-reservation-tg.component.html',
  styleUrl: './form-search-purchase-reservation-tg.component.scss',
})
export class FormSearchPurchaseReservationTgComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private purchaseServiceOrderService: PurchaseServiceOrderService,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''

  employeeConsultantSelected: any = {}
  clientSelected: any = {}
  consultoresAtribuicao: any[] = []

  ngOnInit() {
    this.createForm()
    this.getConsultoresAtribuicao()
  }

  getConsultoresAtribuicao() {
    this.purchaseServiceOrderService.listConsultoresAtribuicao().subscribe({
      next: (response: any) => {
        this.consultoresAtribuicao = response.data ?? []
      },
      error: () => {
        this.consultoresAtribuicao = []
      },
    })
  }

  ngOnChanges() {}

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      tgCode: [''],
      client: [''],
      dateStart: [''],
      dateEnd: [''],
      consultant: [''],
      fornecedorAtribuidoPor: [''],
    })
  }

  addConsultanOperational() {
    const dialogRef = this.dialog.open(
      ModalEmployeeConsultantOperationalComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '1200px',
        minWidth: '1200px',
        maxHeight: '650px',
        data: {
          item: this.employeeConsultantSelected,
          multiSelect: false,
        },
      },
    )
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.formSearch
            .get('consultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearConsultant()
        }
      }
    })
  }

  clearConsultant() {
    this.employeeConsultantSelected = {}
    this.formSearch.get('consultant')!.setValue('')
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.clientSelected = response.selection
          this.formSearch.get('client')!.setValue(this.clientSelected.nomeFantasia)
        } else {
          this.clearClient()
        }
      }
    })
  }

  clearClient() {
    this.clientSelected = {}
    this.formSearch.get('client')!.setValue('')
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = new SearchReservationTgModel()
      searchModel.codigoTg = this.toNullable(this.formSearch.get('tgCode')!.value)
      searchModel.clienteId = this.clientSelected?.id
        ? this.clientSelected.id
        : null
      searchModel.dataInicio = this.formSearch.get('dateStart')!.value
        ? moment(this.formSearch.get('dateStart')!.value).format('YYYY-MM-DD')
        : null
      searchModel.dataFinal = this.formSearch.get('dateEnd')!.value
        ? moment(this.formSearch.get('dateEnd')!.value).format('YYYY-MM-DD')
        : null
      searchModel.consultorOperacionalId = this.employeeConsultantSelected?.id
        ? this.employeeConsultantSelected.id
        : null
      searchModel.fornecedorAtribuidoPor = this.toNullableNumber(
        this.formSearch.get('fornecedorAtribuidoPor')!.value,
      )
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.get('tgCode')!.setValue('')
      this.formSearch.get('client')!.setValue('')
      this.formSearch.get('dateStart')!.setValue('')
      this.formSearch.get('dateEnd')!.setValue('')
      this.formSearch.get('fornecedorAtribuidoPor')!.setValue('')
      this.clearConsultant()
      this.clearClient()

      this.responseSearch.emit({ search: search, model: {} })
    }
  }

  private toNullable(value: string): string | null {
    return value && value.trim().length > 0 ? value : null
  }

  private toNullableNumber(value: any): number | null {
    return value !== null && value !== undefined && value !== '' ? value : null
  }

  checkSearch() {
    if (
      this.formSearch.get('tgCode')!.value.trim().length > 0 ||
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value ||
      this.employeeConsultantSelected?.id ||
      this.clientSelected?.id ||
      this.formSearch.get('fornecedorAtribuidoPor')!.value
    ) {
      return true
    } else {
      return false
    }
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }
}
